var map = {
	"./04-f0a93f1a0fc005e7f011.jpg": 298,
	"./23-622e910f0831f38cef81.jpg": 227,
	"./photo10.png": 95,
	"./photo5.png": 75,
	"./slide4-c702ced0ed6528724fb9.jpg": 626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 531;